/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Minimum_5Inputs */



/**
* | output |
* | --- |
* | "Minimum: 5" |
*
* @param {Options_Backup_Minimum_5Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_minimum_5 = /** @type {((inputs?: Options_Backup_Minimum_5Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Minimum_5Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Minimum : 5")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestens: 5")
	if (locale === "it") return /** @type {LocalizedString} */ ("Minimo: 5")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимум: 5")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mínimo: 5")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最低要求：5")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最小: 5")
	if (locale === "hi") return /** @type {LocalizedString} */ ("न्यूनतम: 5")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mínimo: 5")
	return /** @type {LocalizedString} */ ("Minimum: 5")
});